import { useCallback } from 'react';

var combineRefs = function combineRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (element) {
    return refs.forEach(function (ref) {
      if (!ref) {
        return;
      } // Ref can have two types - a function or an object. We treat each case.


      if (typeof ref === "function") {
        return ref(element);
      } // As per https://github.com/facebook/react/issues/13029
      // it should be fine to set current this way.


      ref.current = element;
    });
  };
};

var useCombinedRefs = function useCombinedRefs() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }

  return useCallback(function (element) {
    return combineRefs.apply(void 0, refs)(element);
  }, refs);
};

var useCombinedRefs$1 = useCombinedRefs;

export { combineRefs, useCombinedRefs$1 as default };
//# sourceMappingURL=use-combined-refs.js.map
